export default __webpack_public_path__ + "static/media/11dsup.1004b35d.svg";